export interface AesTeamNames {
  id: number;
  username: string;
  employeeId: string;
  team: string;
  aesRequestEligible: boolean;
  displayName: string;
}
